
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class JobService {

  




  constructor(private http :HttpClient) { }
  public Data = new BehaviorSubject(null)
  GetJob():Observable<any>{
    return this.http.get(`${env.Server_URL}/Job/GetDB`);
  }

  Get(data:any) {
    return this.http.post(
      `${env.Server_URL}/Job/GetAllPaged`,data
    ) as Observable<any>;
  }
  Post(data: any): Observable<any> {
    return this.http.post<any>(
      `${env.Server_URL}/Job/Create`,
      data
    );
  }
  GetJobById(id) {
    return this.http.get(
      `${env.Server_URL}/Job/GetById?Id=${id}`
    ) as Observable<any>;
  }
  put(data: any): Observable<any> {
    return this.http.post<any>(
      `${env.Server_URL}/Job/Update`,
      data
    );
  }
  Delete(id: number): Observable<any> {
    return this.http.get<any>(
      `${env.Server_URL}/Job/Delete?id=${id}`
    );
    // change detete
  }

}
